function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Observable } from '../../utils/observables/observable';
export var BasePlayerEngineItemPrecursor = /*#__PURE__*/ function() {
    "use strict";
    function BasePlayerEngineItemPrecursor() {
        var _this = this;
        _class_call_check(this, BasePlayerEngineItemPrecursor);
        _define_property(this, "onPlayErrorObservable", new Observable());
        _define_property(this, "attachPlayerErrorsHandler", function(callback) {
            _this.onPlayErrorObservable.registerObserver(callback, _this);
        });
        _define_property(this, "detachPlayerErrorsHandler", function() {
            _this.onPlayErrorObservable.unregisterObservers(_this);
        });
    }
    _create_class(BasePlayerEngineItemPrecursor, [
        {
            key: "prefetch",
            value: function prefetch(loadOptions) {
                return this.load(loadOptions);
            }
        }
    ]);
    return BasePlayerEngineItemPrecursor;
}();

//# sourceMappingURL=player-engine-item-precursor.js.map